module.exports = __webpack_public_path__ + "static/img/bottom_wechat.5c018e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom_wechat.jpg
// module id = W9I1
// module chunks = 13